import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { getAssets } from '@services'
import { AssetsParams, AssetsResponse } from '@interfaces'

export const clearAssetsListDiscover = createAction('clearAssetsListDiscover')

export const fetchAssetsDiscover = createAsyncThunk<
  AssetsResponse,
  AssetsParams
>('fetchAssetsDiscover', async (data: AssetsParams) => {
  const { query, page, assetTypes, selectedFilters, sortBy, ter } = data
  return await getAssets(query, page, assetTypes, selectedFilters, sortBy, ter)
})
